import { makeStyles } from '@mui/styles'
import React, { useCallback } from 'react'
import { useNavigate } from 'react-router'

import ThemeInterface from '@/theme-interface'

const hostnames = [
  'app.orgamax.de',
  'prelive.orgamax.de',
  'test.orgamax.de',
  'localhost:1337',
  'staging.orgamax',
]

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    color: theme.primary,
  },
}))

export default function AiChatAnswerLink(props: React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  const classes = useStyles()
  const navigate = useNavigate()
  const { href, children } = props

  const onClick = useCallback(() => {
    const url = new URL(href)
    const result = url.pathname.slice(1) + url.hash

    if (hostnames.includes(url.hostname)) {
      return navigate(result)
    }

    window.open(href, '_blank', 'noopener,noreferrer')
  }, [href, navigate])

  return (
    <a className={classes.root} onClick={onClick}>
      {children}
    </a>
  )
}
